import { Routes } from '@angular/router';
import { PaymentsModule } from 'app/pages/payments/payments.module';

// Route for the public payment content layout without sidebar, navbar and footer
export const PaymentLayoutRoutes: Routes = [
  {
    path: 'payments',
    loadChildren: () => PaymentsModule
  }
];
